import React, { useEffect, useState } from 'react';
import './NavBar.css';
import { useLocation, useNavigate } from 'react-router-dom';

function NavBar() {
  const location = useLocation();
  const navigate = useNavigate();
  const [viewport, setViewport] = useState(document.documentElement.clientWidth);

  useEffect(() => {
    const handleResize = () => setViewport(document.documentElement.clientWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const scrollToSection = (e, id) => {
    e.preventDefault();
    if (e.target) e.target.blur(); // 👈 Prevent lingering :focus styles

    if (location.pathname !== '/') {
      navigate('/', { state: { scrollTarget: id } });
    } else {
      const target = document.getElementById(id);
      if (target) {
        target.scrollIntoView({ behavior: 'smooth' });
        setTimeout(() => {
          window.history.replaceState(null, '', window.location.pathname);
        }, 100);
      }
    }
  };

  // Scroll to section after redirect
  useEffect(() => {
    if (location.pathname === '/' && location.state?.scrollTarget) {
      const target = document.getElementById(location.state.scrollTarget);
      if (target) {
        setTimeout(() => {
          target.scrollIntoView({ behavior: 'smooth' });
        }, 300);
      }
    }
  }, [location]);

  // Handle active class for visible sections on homepage only
  useEffect(() => {
    const links = document.querySelectorAll('.nav-link');

    if (location.pathname !== '/') {
      links.forEach(link => link.classList.remove('active'));
      return;
    }

    const sections = document.querySelectorAll('.section');
    const thresholds = [0.8, 0.6, 0.4, 0.6, 0.8];
    const observers = [];

    sections.forEach((section, index) => {
      const observer = new IntersectionObserver(
        entries => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              const targetId = entry.target.id;
              links.forEach(link => {
                const scrollTarget = link.getAttribute('data-target');
                link.classList.toggle('active', scrollTarget === targetId);
              });
            }
          });
        },
        { threshold: thresholds[index % thresholds.length] }
      );
      observer.observe(section);
      observers.push(observer);
    });

    return () => {
      observers.forEach(observer => observer.disconnect());
    };
  }, [location]);

  const navBarClasses = `navbar navbar-expand-lg ${viewport >= 992 ? 'desktop sticky-top' : 'mobile'}`;
  const linkClasses = `navbar-brand ${viewport >= 992 ? 'desktop' : 'mobile'}`;
  const logoClasses = `logo ${viewport >= 992 ? 'desktop' : 'mobile'}`;

  const links = [
    { id: 'explore', label: 'Explore the Process' },
    { id: 'features', label: 'Features' },
    { id: 'dataflow', label: 'Dataflow' },
    { id: 'getInTouch', label: 'Get in Touch' }
  ];

  return (
    <nav className={navBarClasses}>
      <a
        href="/"
        className={linkClasses}
        // onClick={(e) => scrollToSection(e, 'banner')}
        draggable="false" onDragStart={(e) => e.preventDefault()}
      >
        <img className={logoClasses} src="./images/navbar/Logo.svg" alt="Your Logo" onContextMenu={(e) => e.preventDefault()} draggable="false" onDragStart={(e) => e.preventDefault()}/>
      </a>

      <div className="container-fluid">
        <div className="col-lg-2"></div>
        <div className="collapse navbar-collapse col-lg-10" id="navbarNav">
          <ul className="navbar-nav">

            {/* Hidden anchor for observing banner */}
            <li style={{ display: 'none' }}>
              <a
                href="#"
                className="nav-link"
                data-target="banner"
                onClick={(e) => scrollToSection(e, 'banner')}
                draggable="false" onDragStart={(e) => e.preventDefault()}
              >
                Banner
              </a>
            </li>

            {links.map(({ id, label }) => (
              <li className="nav-item" key={id}>
                <a
                  href="#"
                  className="nav-link rounded"
                  data-target={id}
                  onClick={(e) => scrollToSection(e, id)}
                  draggable="false" onDragStart={(e) => e.preventDefault()}
                >
                  {label}
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </nav>
  );
}

export default NavBar;